/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPccPushStatus200ResponseData
 */
export interface ResetPccPushStatus200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResetPccPushStatus200ResponseData
     */
    message?: string;
}

/**
 * Check if a given object implements the ResetPccPushStatus200ResponseData interface.
 */
export function instanceOfResetPccPushStatus200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResetPccPushStatus200ResponseDataFromJSON(json: any): ResetPccPushStatus200ResponseData {
    return ResetPccPushStatus200ResponseDataFromJSONTyped(json, false);
}

export function ResetPccPushStatus200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPccPushStatus200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ResetPccPushStatus200ResponseDataToJSON(value?: ResetPccPushStatus200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

